import type { PreRegistrationInputType } from "../schemas/user";

export const PreRegisterUser = async (input: PreRegistrationInputType) => {
  // Send the product replacement request
  const response = await fetch(`${process.env.GATSBY_GAC_API4_URI}/preregister`, {
    method: "POST",
    body: JSON.stringify(input),
    headers: {
      "Content-Type": "application/json",
    },
  });

  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(`Request failed with status: ${response.status} - ${response.statusText}. Server response: ${errorText}`);
  }

  return true;
};
